import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class AtributosService {

  constructor(private _apiService: ApiService) { }

  DataBindToAtributosCheckBoxes(id: any, tipo: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.dataBindToAtributosCheckBoxes}`;
    url = url.replace('{id}', id);
    url = url.replace('{tipo}', tipo);
    return this._apiService.get(url);
  }

  CheckHeaderAtributoStatus(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.checkHeaderAtributoStatus}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  CheckHeaderLocalizacionStatus(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.checkHeaderLocalizacionStatus}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  GetAttributoEmpresaForAttributoTab(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getAttributoEmpresaForAttributoTab}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }
  GetValoresActuales(id: any, tipo: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getValoresActuales}`;
    url = url.replace('{id}', id);
    url = url.replace('{tipo}', tipo);
    return this._apiService.get(url);
  }

  GetAttributoEmpresa(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getAttributoEmpresa}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  AddValoresActuales(valoresActuales: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.addValoresActuales}`;
    return this._apiService.post(url, valoresActuales);
  }

  UpdateValoresActuales(valoresActuales: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateValoresActuales}`;
    return this._apiService.put(url, valoresActuales);
  }

  UpdateHeaderAtributos(id: any, updatedstring: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateHeaderAtributos}`;
    url = url.replace('{id}', id);
    url = url.replace('{updatedstring}', updatedstring);
    return this._apiService.put(url);
  }

  UpdateHeaderAtributosName(id: number, typo: string, attributoname: string | null): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateHeaderAtributosName}`;
    url = url
      .replace('{id}', encodeURIComponent(id.toString()))
      .replace('{typo}', encodeURIComponent(typo))
      .replace('{attributoname}', attributoname !== null ? encodeURIComponent(attributoname) : '');
    return this._apiService.put(url);
  }

  UpdateLocalization(id: any, localizationid: any, headerstatus: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateLocalization}`;
    url = url.replace('{id}', id);
    url = url.replace('{localizationid}', localizationid);
    url = url.replace('{headerstatus}', headerstatus);
    return this._apiService.put(url);
  }

  UpdateRightSideCheckBoxes(id: any, tipo: any, calcularabsentismo, atributoobligatorio, coincidirconlista, multipleconjornada): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateRightSideCheckBoxes}`;
    url = url.replace('{id}', id);
    url = url.replace('{tipo}', tipo);
    url = url.replace('{calcularabsentismo}', calcularabsentismo);
    url = url.replace('{atributoobligatorio}', atributoobligatorio);
    url = url.replace('{coincidirconlista}', coincidirconlista);
    url = url.replace('{multipleconjornada}', multipleconjornada);
    return this._apiService.put(url);
  }

  DeleteValoresActuales(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.deleteValoresActuales}`;
    url = url.replace('{id}', id);
    return this._apiService.delete(url);
  }

}
